
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DailyNumberDisplayerFilterable from '@/components/reports-v3/components/filterables/DailyNumberDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import {getTableName, getSqlColumnRef} from '@/worker/db/sqlHelpers';
import {PermissionsGroup} from '@/store/models.def';
import IncludeTaxToggle from '@/components/IncludeTaxToggle.vue';
import settingx from '@/store/modules/settingx';
import moment from 'moment';

@Component({
	components: {
		DailyNumberDisplayerFilterable,
		IncludeTaxToggle,
	},
})
export default class DashboardQuotationNumberDisplayer extends FilterWidget {
    public get permissionIds(): PermissionsGroup[] {
        return ['dashboard'];
    }

	public todayAmount = 0;
	public yesterdayAmount = 0;
	public bracketAmount = 0;

	public get includeTax() {
		return settingx.now.includeTax;
	}

	public get expensiveHook() {
		const { selectedAsOfDate, includeTax } = this;
		return JSON.stringify([selectedAsOfDate, includeTax]);
	}

	public async expensiveCalc() {
		this.generateLoadingText(0.2, 0.3);

		const todayStart = moment(this.selectedAsOfDate).startOf('day').valueOf();
		const todayEnd = moment(this.selectedAsOfDate).endOf('day').valueOf();
		const sevenDaysAgo = moment(this.selectedAsOfDate).add(-7, 'day').startOf('day').valueOf();

		const amountCol = getSqlColumnRef('dashboardQuotation', this.includeTax ? 'amountWithTax' : 'amount');
		const table = getTableName('dashboardQuotation');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['dashboardQuotation']);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.3, 0.6);

		const [todayResult, weekResult] = await Promise.all([
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST(${amountCol} AS DOUBLE)) as total, COUNT(*) as cnt
				FROM ${table}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${todayStart} AND ${todayEnd}
			`),
			queryHead.rawQuery(`
				SELECT SUM(TRY_CAST(${amountCol} AS DOUBLE)) as total
				FROM ${table}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) BETWEEN ${sevenDaysAgo} AND ${todayEnd}
			`),
		]);
		this.checkInterrupted(jobId);

		this.todayAmount = Number(todayResult[0] && todayResult[0].total) || 0;
		this.yesterdayAmount = (Number(weekResult[0] && weekResult[0].total) || 0) / 7;
		this.bracketAmount = Number(todayResult[0] && todayResult[0].cnt) || 0;

		this.generateLoadingText(1);
		this.saveHistory('todayAmount', 'yesterdayAmount', 'bracketAmount');
	}
}
